module.exports = __webpack_public_path__ + "static/media/promoted.d9309693.svg";